// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class Uuid {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Uuid {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  bitsLow(): bigint {
    return this.bb!.readUint64(this.bb_pos)
  }

  bitsHigh(): bigint {
    return this.bb!.readUint64(this.bb_pos + 8)
  }

  static sizeOf(): number {
    return 16
  }

  static createUuid(builder: flatbuffers.Builder, bits_low: bigint, bits_high: bigint): flatbuffers.Offset {
    builder.prep(8, 16)
    builder.writeInt64(BigInt(bits_high ?? 0))
    builder.writeInt64(BigInt(bits_low ?? 0))
    return builder.offset()
  }
}
